// Tri, tranches alphabétiques et dégradé de charte — logique PURE.
// Extrait du single-file index.html (l. 986-1032) le 2026-08-05.

/** Normalise pour comparer : sans accents, en minuscules. */
export function norm(s) {
  return (s || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();
}

/**
 * Clé de tri alphabétique : ignore les déterminants de tête.
 * « L'Oréal » se range à O, « Les Laboratoires X » à L(aboratoires).
 */
export function sortKey(label) {
  return norm(label)
    .trim()
    .replace(/^(l'|d'|le |la |les |l |du |de |des |aux |au |the )/, "")
    .trim();
}

// ── Charte graphique EtikPharma v4 ────────────────────────────────────────────
// CORRIGÉ le 2026-08-05. L'original déclarait :
//     // Dégradé charte (pétrole → corail)
//     const _PETROLE=[11,122,117], _CORAIL=[255,107,87];
// Or [11,122,117] est #0b7a75 et [255,107,87] est #ff6b57 : ni la charte v4
// (pétrole #2D7A8B + corail #FF8463), ni le teal legacy #00CCBC — une TROISIÈME
// palette, sous un commentaire affirmant appliquer la charte. On aligne sur
// l'intention écrite dans ce commentaire, la seule qui soit documentée.
export const PETROLE = [45, 122, 139]; // #2D7A8B
export const CORAIL = [255, 132, 99]; // #FF8463

/**
 * Couleur d'accent interpolée le long d'une liste (pétrole en tête → corail en
 * queue), pour donner une progression visuelle à une grille de cartes.
 */
export function accentAt(i, total) {
  const t = total > 1 ? i / (total - 1) : 0;
  const canal = (k) => Math.round(PETROLE[k] + (CORAIL[k] - PETROLE[k]) * t);
  const [r, g, b] = [canal(0), canal(1), canal(2)];
  return { solid: `rgb(${r},${g},${b})`, faint: `rgba(${r},${g},${b},.07)` };
}

/**
 * Découpe une liste DÉJÀ TRIÉE en tranches équilibrées étiquetées par lettres
 * (« A–C », « D–F »…), pour la navigation d'un annuaire long.
 * Retourne [] quand la liste est assez courte pour ne pas mériter de navigation.
 */
export function buildRanges(items, size = 36) {
  if (!Array.isArray(items) || items.length <= size) return [];
  const n = Math.ceil(items.length / size);
  const par = Math.ceil(items.length / n);
  const lettre = (x) => (sortKey(x.label || x.display_name)[0] || "?").toUpperCase();
  const out = [];
  for (let i = 0; i < items.length; i += par) {
    const tranche = items.slice(i, i + par);
    const a = lettre(tranche[0]);
    const b = lettre(tranche[tranche.length - 1]);
    out.push({ key: String(i), label: a === b ? a : `${a}–${b}`, items: tranche });
  }
  return out;
}
